import { environmentHttpClient as httpClient } from "client/Api/httpClient";


export type WorkspaceSettingsViewModel = {
	model: WorkspaceSettingsModel;
	isEmbedSharedTileGroupEnabled: boolean;
};

export enum ActivityEmailKind {
	Daily = 0,
	Weekly = 1
}

export type WorkspaceSettingsModel = {
	automaticallyReorderTilesForNoneEditableTileGroups: boolean;
	isPercentileTileScalingEnabledForEmbedTileGroup: boolean;
	isFrequentlyUsedTilesGroupEnabled: boolean;
	areActivityEmailsEnabled: boolean;
	defaultActivityEmailKind: ActivityEmailKind | null;
};

export type WorkspaceSettingsActivityEmailPreferenceSaveModel = {
	activityEmailKind: ActivityEmailKind | null;
};

export function getPageViewModel(signal?: AbortSignal): Promise<WorkspaceSettingsViewModel> {
	return httpClient.get<WorkspaceSettingsViewModel>(
		"UiApi/WorkspaceManagement",
		undefined,
		{ signal }
	);
}

export function setMyWorkspaceAsTemplate(): Promise<void> {
	return httpClient.post<void>("UiApi/WorkspaceManagement/SetMyWorkspaceAsTemplate");
}

export function setMyWorkspaceAsTemplateForNewAndCurrentUsers(): Promise<void> {
	return httpClient.post<void>(
		"UiApi/WorkspaceManagement/SetMyWorkspaceAsTemplateForNewAndCurrentUsers"
	);
}

export function refreshWorkspaces(): Promise<void> {
	return httpClient.put<void>("UiApi/WorkspaceManagement/RefreshWorkspaces");
}

export function save(model: WorkspaceSettingsModel, signal?: AbortSignal): Promise<void> {
	return httpClient.put<void>(
		"UiApi/WorkspaceManagement",
		model,
		{ signal }
	);
}

export function enableAllAppLinksForSupportedApps(): Promise<void> {
	return httpClient.post<void>("UiApi/WorkspaceManagement/EnableAllAppLinksForSupportedApps");
}

export function applyActivityEmailPreferenceToCurrentUsers(
	model: WorkspaceSettingsActivityEmailPreferenceSaveModel,
	signal?: AbortSignal
): Promise<void> {
	return httpClient.post<void>(
		"UiApi/WorkspaceManagement/ApplyActivityEmailPreferenceToCurrentUsers",
		model,
		{ signal }
	);
}